import type { SVGProps } from "react";
export interface Globe02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Globe02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Globe02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 2.5V2a1.125 1.125 0 0 1 2.25 0v.5l-.008.238c-.089 1.174-.806 2.094-1.148 2.616-.44.672-.516.949-.402 1.29.229.687.15 1.409-.35 1.971-.416.467-1 .677-1.445.788-.558.14-1.206.188-1.787.207.158.195.344.379.533.521.287.216.457.243.482.243.97 0 2.018.314 2.879.745.806.403 1.675 1.026 2.099 1.83a.5.5 0 0 0 .09.05c.186.085.345.12.726.247.297.099.764.267 1.148.62.444.409.683.968.683 1.634 0 .406-.127.802-.258 1.12-.14.336-.329.688-.538 1.033-.418.692-.967 1.438-1.517 2.117a24 24 0 0 1-1.603 1.799 8 8 0 0 1-.67.612c-.099.08-.214.167-.336.239-.067.04-.343.205-.703.205-.69 0-1.037-.518-1.128-.668a2.8 2.8 0 0 1-.255-.586c-.056-.173-.11-.37-.158-.548-.052-.187-.102-.37-.158-.555-.117-.378-.24-.689-.381-.916a1 1 0 0 0-.176-.22l-.1-.065c-1.293-.431-1.803-1.675-2.02-2.556-.201-.819-.24-1.68-.247-2.265a4 4 0 0 0-.449-.189c-.511-.186-1.395-.447-2.209-.91l-.342-.21-.053-.036c-.645-.43-1.274-.845-1.796-1.31l-.217-.203-.077-.085A1.125 1.125 0 0 1 2.8 9.707l.086.076.311.277c.34.278.78.573 1.374.97l.053.035.228.14c.545.31 1.153.487 1.845.738.342.125.78.296 1.136.56.402.298.791.787.791 1.497 0 .55.021 1.314.183 1.973.178.72.42.917.548.96.712.237 1.175.75 1.474 1.23.296.476.487 1.008.62 1.443l.007.02c.342-.364.727-.803 1.106-1.271a18 18 0 0 0 1.341-1.868 5.6 5.6 0 0 0 .384-.73c.09-.215.087-.288.087-.257v-.003l-.028-.015a2 2 0 0 0-.265-.102c-.182-.06-.618-.183-.947-.333-.372-.169-.853-.469-1.14-1.044-.086-.172-.445-.533-1.123-.872-.64-.32-1.341-.507-1.872-.507-.724 0-1.368-.345-1.83-.692a5.5 5.5 0 0 1-1.231-1.309c-.288-.43-.595-1.036-.595-1.655 0-.344.1-.796.473-1.153.366-.349.822-.44 1.184-.44l.599-.003c.6-.01 1.186-.041 1.627-.151q.09-.025.153-.047c-.365-1.343.27-2.382.707-3.051.467-.714.72-1.073.777-1.457l.011-.166Zm6.626.216a1.125 1.125 0 0 1 1.312.743l.031.111.105.519c.234 1.262.331 2.866-.442 4.413-.454.909-.108 3.477 3.132 3.882l.344.037.113.016a1.125 1.125 0 0 1-.2 2.23l-.115-.005-.42-.045c-4.76-.595-6.025-4.803-4.867-7.12.456-.911.439-1.935.247-2.986l-.093-.451-.02-.115a1.126 1.126 0 0 1 .873-1.229"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12 .875s11.125 4.981 11.125 11.126Z"
      />
    </svg>
  );
}
